import { Fragment, useState } from 'react';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Button, Menu } from '@pocketlaw/tetris';
import { useWorkflowCheck } from 'app/domains/workflows/features/WorkflowCheckProvider';
import { ContextDialog } from './ContextDialog';
export function RerunWorkflowButton() {
    const { type, startCheck, approvalWorkflows, signatoryWorkflows } = useWorkflowCheck();
    const [withContext, setWithContext] = useState(false);
    const [dialogState, setDialogState] = useState({ show: false });
    const workflows = type === 'approval' ? approvalWorkflows : signatoryWorkflows;
    const hasWorkflows = workflows.length > 0;
    const singleWorkflow = workflows.length === 1;
    const multipleWorkflows = workflows.length > 1;
    const hideDialog = () => setDialogState({ show: false });
    const rerunSingleWorkflow = () => {
        startCheck(workflows[0].id);
    };
    const rerunSingleWorkflowWithContext = () => {
        setDialogState({ show: true, workflowId: workflows[0].id });
    };
    const rerunMultipleWorkflow = (workflowId) => {
        if (withContext) {
            setDialogState({ show: true, workflowId });
        }
        else {
            startCheck(workflowId);
        }
    };
    if (!hasWorkflows) {
        return (<Button $stretch disabled size="small" appearance="secondary">
        <Trans comment="Document workflow check - No workflows label">No rules available</Trans>
      </Button>);
    }
    return (<Fragment>
      {dialogState.show && (<ContextDialog workflowId={dialogState.workflowId} onClose={hideDialog} onSubmit={startCheck}/>)}

      <Menu.Root target={<Button $stretch size="small" appearance="secondary">
            <Trans comment="Document workflow check - Rerun check button label">Rerun check</Trans>
          </Button>}>
        {singleWorkflow && (<Fragment>
            <Menu.Item onClick={rerunSingleWorkflow}>
              <Menu.ItemText primary={t({
                comment: 'Document workflow check - Rerun check button label',
                message: 'Rerun',
            })} secondary={t({
                comment: 'Document workflow check - Rerun check button description',
                message: 'Rerun check with same rule',
            })}/>
            </Menu.Item>

            <Menu.Item onClick={rerunSingleWorkflowWithContext}>
              <Menu.ItemText primary={t({
                comment: 'Document workflow check - Rerun check button label',
                message: 'Rerun with more context',
            })} secondary={t({
                comment: 'Document workflow check - Rerun check button description',
                message: 'Rerun check with same rule and more context',
            })}/>
            </Menu.Item>
          </Fragment>)}

        {multipleWorkflows && (<Fragment>
            <Menu.ItemSwitch closeOnClick={false} checked={withContext} onChange={setWithContext}>
              <Menu.ItemText primary={t({
                comment: 'Document workflow check - Add additional context label',
                message: 'Add additional context',
            })}/>
            </Menu.ItemSwitch>

            <Menu.Divider />

            <Menu.Label>
              <Trans comment="Document workflow check - Select rule label">Select rule</Trans>
            </Menu.Label>

            {workflows.map((workflow) => (<Menu.Item key={workflow.id} onClick={() => rerunMultipleWorkflow(workflow.id)}>
                <Menu.ItemText primary={workflow.name}/>
              </Menu.Item>))}
          </Fragment>)}
      </Menu.Root>
    </Fragment>);
}
